/** The error name when a worker times out. */
export const WorkerTimeoutName = 'Worker Timeout';

/** The error name when a worker exits before posting a result. */
export const WorkerExitName = 'Worker Exit';
